import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICostAccountingType } from '../../../../models/cost-accounting-type.model';
import { CostAccountingTypeFacade } from '../../../../services/facades/master-data/cost-accounting-type.facade';
import { ICostAccountingTypeState } from '../../../../services/facades/master-data/cost-accounting-type-state.model';
import { Observable } from 'rxjs';

@Component({
    templateUrl: './cost-accounting-type-dialog.component.html',
    styleUrls: [ './cost-accounting-type-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostAccountingTypeDialogComponent implements OnInit, AfterViewInit {
    public costAccountingTypeState$: Observable<ICostAccountingTypeState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ICostAccountingType,
        private myMatDialogRef: MatDialogRef<CostAccountingTypeDialogComponent>,
        private myCostAccountingTypeFacade: CostAccountingTypeFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costAccountingTypeState$ = this.myCostAccountingTypeFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((v: ICostAccountingType) => {
            this.validateDialogFields(v);
        });
    }

    public async save(): Promise<void> {
        const data = this.formGroup.value as ICostAccountingType;
        await this.myCostAccountingTypeFacade.addCostAccountingType(data);
        this.myMatDialogRef.close(true);
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(costAccountingType: ICostAccountingType): void {
        // Validations to disable saving/editing
        if (!costAccountingType.name ||
            !costAccountingType.materialPrice ||
            !costAccountingType.materialQuantity ||
            !costAccountingType.salesPrice ||
            !costAccountingType.salesVolume ||
            !costAccountingType.productionTime) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
